"use strict";
/**
 * ModalService - Generic modal dialog management
 * Handles showing message and confirmation modals
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalService = void 0;
class ModalService {
    /**
     * Initialize modal service - must be called once on app load
     */
    static init() {
        this.modal = document.getElementById('modal');
        this.messageEl = document.getElementById('modal-message');
        this.titleEl = document.getElementById('modal-title');
        this.closeBtn = document.getElementById('modal-close');
        this.okBtn = document.getElementById('modal-ok');
        this.cancelBtn = document.getElementById('modal-cancel');
        this.confirmBtn = document.getElementById('modal-confirm');
        this.backdrop = this.modal.querySelector('.modal-backdrop');
    }
    /**
     * Show modal with OK button only
     */
    static show(message, title = 'Warning') {
        this.titleEl.textContent = title;
        this.messageEl.textContent = message;
        this.modal.style.display = 'flex';
        // Hide confirmation buttons
        this.cancelBtn.style.display = 'none';
        this.confirmBtn.style.display = 'none';
        this.okBtn.style.display = 'block';
        const closeModal = () => {
            this.modal.style.display = 'none';
        };
        this.closeBtn.onclick = closeModal;
        this.okBtn.onclick = closeModal;
        this.cancelBtn.onclick = closeModal;
        // Close modal when clicking backdrop
        if (this.backdrop) {
            this.backdrop.onclick = closeModal;
        }
    }
    /**
     * Show confirmation modal with Cancel and Confirm buttons
     */
    static confirm(message, title, onConfirm) {
        this.titleEl.textContent = title;
        this.messageEl.textContent = message;
        this.modal.style.display = 'flex';
        // Show confirmation buttons
        this.okBtn.style.display = 'none';
        this.cancelBtn.style.display = 'block';
        this.confirmBtn.style.display = 'block';
        const closeModal = () => {
            this.modal.style.display = 'none';
        };
        this.closeBtn.onclick = closeModal;
        this.cancelBtn.onclick = closeModal;
        this.confirmBtn.onclick = () => {
            onConfirm();
            closeModal();
        };
        // Close modal when clicking backdrop
        if (this.backdrop) {
            this.backdrop.onclick = closeModal;
        }
    }
}
exports.ModalService = ModalService;
